<template>
  <strong>
    <v-chip
      :color="payload.color"
      :text-color="payload.textColor"
      class="text-uppercase"
      label
    >
      {{ payload.label }}
    </v-chip>
  </strong>
</template>

<script>
import DataTableChipColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableChipColumn.vue';
import analysisTableUserStatus from 'Arch/enums/analysisTableUserStatus';

export default {
  name: 'ClientStatusAnalysisColumn',
  extends: DataTableChipColumnVue,
  data: () => ({
    status: analysisTableUserStatus,
  }),
};
</script>
